export default __webpack_public_path__ + "static/js/iconfont.js";